import { ADD, REMOVE } from "./blogActions";

// We need to have an initial state values
const initialState = {
  id: "",
  title: "",
  faceImg: "",
  description: "",
  meta_description: "",
  meta_title: "",
  row: undefined
};

// Then we need to have the reducer

const blogReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case ADD:
      return {
        ...state,
        id: payload.id,
        title: payload.title,
        faceImg: payload.faceImg,
        description: payload.description,
        meta_description: payload.meta_description ?? "",
        meta_title: payload.meta_title ?? "",
        row: payload?.row
      };
    case REMOVE:
      return {
        ...state,
        id: "",
        title: "",
        faceImg: "",
        description: "",
        meta_description: "",
        meta_title: "",
        row: undefined
      };
    default:
      return state;
  }
};

export default blogReducer;
